import { Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { Link } from "react-router";

import { PlatformIcons } from "~/components/UI/PlatformIcons";
import { tradeLabelByMarketStatus } from "~/constants/tradeLabelByMarketStatus";
import { TradeBonus } from "~/feature/event/components/MarketCalculator/components/TradeBonus";
import { usePlatformTradeLink } from "~/feature/event/hooks/usePlatformTradeLink";
import { PlatformClickPlacement } from "~/scripts/platformClick";
import type { IAggregatedEvent, IMarket } from "~/types/event";

import * as Styled from "./TradeOn.styles";

interface ITradeOnProps {
  market: IMarket;
  event: IAggregatedEvent;
}

export const TradeOnResolved: FC<ITradeOnProps> = ({ market, event }) => {
  const { href, platformName, handleClick } = usePlatformTradeLink(
    market,
    event,
    PlatformClickPlacement.Calculator
  );

  return (
    <Stack sx={{ gap: 1, width: "100%" }}>
      <Styled.CardBox>
        <Stack sx={{ flexDirection: "row", width: "100%", alignItems: "center" }}>
          <Stack
            direction="row"
            spacing={1.5}
            sx={{ alignItems: "center", flex: 1 }}
          >
            <PlatformIcons platforms={market.platform} size={32} />
            <Typography variant="body1" sx={{ fontWeight: 700 }}>
              {platformName}
            </Typography>
          </Stack>
          <Styled.TradeButton
            component={Link}
            to={href}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            size="small"
            onClick={handleClick}
          >
            {tradeLabelByMarketStatus[market.unifiedStatus]}
          </Styled.TradeButton>
        </Stack>
        <TradeBonus platform={market.platform} />
      </Styled.CardBox>
    </Stack>
  );
};
